(function () {
  function openOcuCart(e) {
  if (e) e.preventDefault();

  const drawer = document.querySelector('.ocu-cart-drawer');
  const overlay = document.querySelector('.ocu-cart-overlay');
  const container = document.querySelector('.ocu-cart-container');

  if (drawer) drawer.classList.add('ocu-visible');
  if (overlay) overlay.classList.add('ocu-visible');
  if (container) container.classList.add('ocu-visible');

  document.body.classList.add('overflow-hidden');

  updateHeaderCartCount(); 
}

function closeOcuCart() {
  const drawer = document.querySelector('.ocu-cart-drawer');
  const overlay = document.querySelector('.ocu-cart-overlay');
  const container = document.querySelector('.ocu-cart-container');

  if (drawer) drawer.classList.remove('ocu-visible');
  if (overlay) overlay.classList.remove('ocu-visible');
  if (container) container.classList.remove('ocu-visible');

  document.body.classList.remove('overflow-hidden');

  updateHeaderCartCount(); 
}

  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-open-ocu-cart')) {
      openOcuCart(e);
      return;
    }

    if (
      e.target.closest('.ocu-cart-overlay') ||
      e.target.closest('[aria-label="Close"]') ||
      e.target.closest('.ocu-cart-header') ||
      e.target.closest('.ocu-close')
    ) {
      closeOcuCart();
    }
  }, true);
})();

function updateHeaderCartCount() {
  fetch('/cart.js', {
    headers: { Accept: 'application/json' }
  })
    .then(res => res.json())
    .then(cart => {
      const count = cart.item_count || 0;

      const bubble = document.querySelector('[data-cart-count-bubble]');
      const countEl = document.querySelector('[data-cart-count]');

      if (!bubble || !countEl) return;

      countEl.textContent = count;

      if (count > 0) {
        bubble.style.display = 'flex';
      } else {
        bubble.style.display = 'none';
      }
    });
}

document.addEventListener('DOMContentLoaded', updateHeaderCartCount);